var Category = /** @class */ (function () {
    function Category() {
    }
    Category.createFromApi = function (id, name) {
        return Object.assign({}, this, {
            Id: id,
            name: name
        });
    };
    return Category;
}());
export { Category };
